<template>
  <div class="p-6">
    <h4 class="text-base fony-semibold mb-8">LOGO Settings</h4>
    <div class="mb-8 flex">
      <div class="w-16 text-gray-800 font-sm font-semibold flex-shrink-0">
        <label>LOGO</label>
      </div>
      <div class="w-full">
        <div class="flex items-center gap-2 mb-6">
          <div
            class="border border-gray-200 p-1 rounded-md relative flex items-center justify-center"
            v-if="config.image"
          >
            <img :src="config.image" alt="" class="w-10 h-10 object-contain" />
            <span
              @click="clearImage"
              class="bg-black cursor-pointer rounded-full absolute -top-1 -right-1 flex items-center justify-center"
            >
              <XIcon class="text-white w-3 h-3" />
            </span>
          </div>
          <div
            class="hover:text-main cursor-pointer border border-gray-200 rounded-md px-2 py-0.5"
            @click="$refs.inputFile.click()"
          >
            Upload
            <input
              type="file"
              ref="inputFile"
              accept="image/*"
              class="hidden"
              @change="changeFileUpload"
            />
          </div>
        </div>
        <div class="flex mb-6 flex-wrap gap-2">
          <div
            class="border border-gray-200 p-1 rounded-md relative flex items-center justify-center cursor-pointer"
            v-for="(logo, i) in LogoSamples"
            @click="UpdateLogo(logo, i)"
            :key="i"
          >
            <img :src="logo" class="w-10 h-10" alt="" />
          </div>
        </div>
      </div>
    </div>
    <div
      class="mb-8 flex flex-col gap-4"
      :class="{ 'grayscale pointer-events-none opacity-75': !config.image }"
    >
      <div class="w-16 text-gray-800 font-sm font-semibold flex-shrink-0">
        <label>Settings</label>
      </div>
      <div class="w-full">
        <div
          class="mb-6"
          :class="{ 'opacity-40 pointer-events-none': !config.image_default }"
        >
          <label for="" class="mb-2 block">Color picker</label>
          <div class="flex flex-wrap gap-1">
            <color-picker
              v-model:pureColor="color_picker"
              :pickerType="'chrome'"
              :format="'hex'"
              :disableAlpha="true"
              :shape="'circle'"
              :isWidget="false"
            />
          </div>
        </div>
        <div class="mb-6">
          <div class="flex items-center">
            <input
              :disabled="!config.image"
              @change="setHideBackground"
              :checked="config.imageOptions.hideBackgroundDots"
              id="checked-corner_custom_color"
              type="checkbox"
              value=""
              class="w-4 h-4 accent-success bg-gray-100 border-gray-200 rounded"
            />
            <label
              for="checked-corner_custom_color"
              class="ml-2 text-sm font-medium text-grow"
            >
              Hide Background Dots</label
            >
          </div>
        </div>
        <div class="mb-6">
          <label for="" class="mb-2 block">Image rounded (px)</label>
          <input
            type="range"
            min="0"
            max="300"
            step="10"
            v-model="config.imageOptions.rounded"
            class="accent-success w-full h-2 bg-gray-200 rounded-lg appearance-none cursor-pointer"
          />
        </div>
        <div class="mb-6">
          <label for="" class="mb-2 block">Image Size</label>
          <input
            type="range"
            min="0"
            max="10"
            step="0.1"
            v-model="config.imageOptions.imageSize"
            class="accent-success w-full h-2 bg-gray-200 rounded-lg appearance-none cursor-pointer"
          />
        </div>
        <div class="mb-6">
          <label for="" class="mb-2 block">Margin</label>
          <input
            :disabled="!config.image"
            type="number"
            :value="config.imageOptions.margin"
            @change="changeMarginImage"
            class="h-10 bg-gray-200 px-2 rounded-md outline-none"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { XIcon } from 'vue-tabler-icons';
import configMixins from '../config.mixin';
import { PaletteIcon } from 'vue-tabler-icons';
import { useQrCreateStore } from '~~/stores/qrcreate';
import { notify } from '@kyvg/vue3-notification';
export default {
  mixins: [configMixins],
  data() {
    return {
      LogoSamples: [
        `data:image/svg+xml;base64,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`,
        `data:image/svg+xml;base64,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`,
        `data:image/svg+xml;base64,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`,
      ],
      color_picker: '#000000',
    };
  },
  setup() {
    const qrcreate = useQrCreateStore();

    return {
      qrcreate,
    };
  },
  components: {
    XIcon,
    PaletteIcon,
  },
  methods: {
    changeMarginImage(e) {
      this.qrcreate.setImageOptions({
        margin: e.target.value,
      });
    },
    changeSizeImage(e) {
      this.qrcreate.setImageOptions({
        imageSize: e,
      });
    },
    changeRoundedImage(e) {
      this.qrcreate.setImageOptions({
        rounded: e,
      });
    },
    setHideBackground(e) {
      this.qrcreate.setImageOptions({ hideBackgroundDots: e.target.checked });
    },
    async changeFileUpload(e) {
      var files = e.target.files;
      if (files.length) {
        if (files[0].size > 5 * 1024 * 1024) {
          e.target.value = '';
          notify({
            text: 'Max file size is 5MB',
            type: 'warn',
          });
          return;
        }
        var base64 = await this.getBase64(files[0]);
        if (base64) {
          this.config.image_default = false;
          this.qrcreate.setImage({
            image: base64,
          });
        }
      }
    },
    async UpdateLogo(logo, i) {
      if (this.config.dotsOptions.color) {
        this.color_picker = this.config.dotsOptions.color;
      }
      this.config.image_default = true;
      var data = {
        image: logo,
      };
      if (this.color_picker) {
        data.color = this.color_picker;
      }
      this.qrcreate.setImage(data);
    },
    clearImage() {
      this.config.image_default = false;
      this.qrcreate.setImage({
        image: '',
      });
    },
    getBase64(file) {
      return new Promise((resolve, reject) => {
        var reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function () {
          return resolve(reader.result);
        };
        reader.onerror = function (error) {
          return reject(error);
        };
      });
    },
  },
  watch: {
    color_picker(v) {
      if (this.config.image_default && this.config.image) {
        this.qrcreate.setImage({
          image: this.config.image,
          color: v,
        });
      }
    },
  },
};
</script>
